import { render, staticRenderFns } from "./alertError.vue?vue&type=template&id=73a4b391"
import script from "./alertError.vue?vue&type=script&lang=js"
export * from "./alertError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports